import {parseISO, format, formatDistanceToNow} from 'date-fns';

export const formatTimeAgo = (date?: Date | string) => {
  if (!date) return '';
  const raw = date.toString();
  const normalized = /(Z|[+-]\d{2}:?\d{2})$/.test(raw) ? raw : `${raw}Z`;
  const parsed = parseISO(normalized);
  if (isNaN(parsed.getTime())) return '';
  return formatDistanceToNow(parsed, {addSuffix: true});
};

export const notificationTimeTextConvertor = (dateCreated: Date) => {
  const dateSubtitle = parseISO(dateCreated.toString() + 'Z');
  let formattedDateSubtitle = '';

  if (new Date().getTime() - dateSubtitle.getTime() > 7 * 24 * 60 * 60 * 1000) {
    formattedDateSubtitle = format(dateSubtitle, 'dd-MM-yyyy HH:mm');
  } else {
    formattedDateSubtitle = `On ${format(dateSubtitle, 'EEEE p')}`;
  }
  return formattedDateSubtitle;
};

export const formatDateTime = (date: string) => {
  const dateParsed = parseISO(date.toString() + 'Z');
  return format(dateParsed, 'dd-MM-yyyy');
};

export const formatDateTimeTextFormat = (date: string) => {
  const dateParsed = parseISO(date.toString() + 'Z');
  return format(dateParsed, 'do MMMM yyyy');
};
